
export default function Vision() {
  return (
    <section className="py-24 px-6 bg-gradient-to-br from-[#F0FDFA] via-white to-[#FFF7ED]">
      <div className="max-w-[900px] mx-auto text-center">
        <h2 className="text-4xl font-bold text-gray-900 mb-8">
          构建出口合规的底层管理基础设施
        </h2>

        <div className="p-10 rounded-2xl border border-[#14B8A6]/20 bg-white shadow-sm mb-12">
          <p className="text-lg text-gray-600 leading-relaxed">
            星贸云致力于将出口业务的资料结构与数据关系模型化，
            <br />
            持续提升企业在复杂监管环境下的管理稳定性。
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {[
            { label: '结构化', sub: '数据关系模型化', color: 'text-[#14B8A6]', bg: 'bg-[#F0FDFA] border-[#14B8A6]/20' },
            { label: '可追溯', sub: '完整链路留痕', color: 'text-[#FF6B35]', bg: 'bg-[#FFF7ED] border-orange-200' },
            { label: '可解释', sub: '规则透明可审计', color: 'text-[#14B8A6]', bg: 'bg-[#F0FDFA] border-[#14B8A6]/20' },
          ].map((item, i) => (
            <div key={i} className={`p-6 rounded-xl border ${item.bg}`}>
              <div className={`text-3xl font-bold mb-2 ${item.color}`}>{item.label}</div>
              <p className="text-sm text-gray-500">{item.sub}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
